import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faSort, faSortDown, faSortUp } from '@fortawesome/pro-solid-svg-icons';

import { Order, TableSortParameters } from '../Table.interface';

export const getSortIcon = <T>(
  params: TableSortParameters<T>,
  sortItem: keyof T | string
): IconDefinition => {
  if (params?.key === sortItem) {
    if (params?.mode === Order.DESC) {
      return faSortDown;
    } else if (params?.mode === Order.ASC) {
      return faSortUp;
    } else {
      return faSort;
    }
  } else {
    return faSort;
  }
};

export const determineNextOrder = <T>(
  params: TableSortParameters<T>,
  sortItem: keyof T | string
): Order | undefined => {
  if (sortItem === params?.key) {
    if (params?.mode === Order.DESC) {
      return Order.ASC;
    } else if (params?.mode === Order.ASC) {
      return Order.DESC;
    } else {
      return undefined;
    }
  } else {
    return Order.ASC;
  }
};
